import './EditAssetModal.scss';
import React, { useState } from 'react';
import Modal from '../modal/Modal';
import { useTranslation } from 'react-i18next';
import AssetMetadata from '../assetMetadata/AssetMetadata';
import Server from '../../js/config/_server';
import { apiPatch } from '../../js/api';
import { generalStore } from '../../store';
import { RESPONSE } from '../../js/_constants';

const EditAssetModal= ({
    onClose,
    asset,
    succesfull
}) => {
    const { t } = useTranslation();
    const { setAlert } = generalStore();
    const [isSetMetadataReady, setIsSetMetadataReady] = useState(false)
    const [editPayload, setEditPayload] = useState({
            title: asset.title,
            description: asset.description,
            expirationDate: asset.expirationDate
        })
    const [isEditing, setIsEditing] = useState(false)

    const onEditClick = async () => {
        const url = Server.baseUrl + asset[RESPONSE.ID];
        const options = {
            body: {
                title: editPayload?.title,
                description: editPayload?.description,
                usageTo: editPayload?.expirationDate + 'T00:00:00+02:00'
            }
        }

        await apiPatch(url, options).then(async() => {
            setIsEditing(false);
            setAlert({
                message: t('asset_update_success'),
                type: 'info',
                display: true
            });
            succesfull();
            onClose();
        }).catch((error) => {
            console.error('update error:', error);
            setAlert({
                message: t('asset_update_failed'),
                type: 'warning',
                display: true
            });
            setIsEditing(false);
        });
    }
    
    return (
        <Modal
            show
            onClose={onClose}
            className='edit-asset-modal'
            onAction={onEditClick}
            onCancel={onClose}
            localeAction={t('update')}
            isLoading={isEditing}
            disabled={!isSetMetadataReady}
        >
            <Modal.Title>{t('update_content_title')}:</Modal.Title>
            <Modal.Content>
                <AssetMetadata asset={asset} editMode assetBlob='' checkIfReady={setIsSetMetadataReady} setPayload={setEditPayload}/>
            </Modal.Content>
        </Modal>
    )
}

export default EditAssetModal